import React, { Component } from "react";
import { Image, Typography } from "antd";
import AssessmentTag from "./AssessmentTag";

const { Link } = Typography;

export default class ImageListPreview extends Component {
  renderCount = (current) => {
    var imageInfo = this.props.images[current - 1];
    if (imageInfo) {
      return (
        <>
          <Link
            href={imageInfo["page url"]}
            target="_blank"
            style={{
              color: "white",
              textDecoration: "underline",
              marginRight: "1rem",
            }}
          >
            {imageInfo.title.slice(5)}
          </Link>
          <AssessmentTag type="file type" text={imageInfo.file_type} />
          <AssessmentTag type="resolution" text={imageInfo.resolution} />
        </>
      );
    }
    return "-";
  };

  render() {
    const images = this.props.images;
    const imagesPreview = [];

    const w = this.props.width;
    const h = this.props.height;

    images.forEach((img) => {
      imagesPreview.push(
        <Image
          width={w}
          height={h}
          alt={img["title"]}
          src={img["thumbnail url"]}
          fallback="https://www.fluttercampus.com/img/4by3.webp"
        />
      );
    });

    return (
      <Image.PreviewGroup
        preview={{
          countRender: this.renderCount,
        }}
      >
        {imagesPreview}
      </Image.PreviewGroup>
    );
  }
}
